export const Environmental = 
{
    Metadata:{Name:'Environmental',maxColumn:4,numRows:4},
    Sections:
    [
        {
            Headers:[
                "Gestational/Environmental: Please check all appropriate boxes",
                "Yes",
                "No",
                "Unsure",
                "Comments"
            ],
            Questions:[
                {
                    Prompt:"Did your Biological Mother use alcohol during her pregnancy with you",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Did your Biological Mother use substances during her pregnancy with you",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Were you low body weight when you were born",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
                {
                    Prompt:"Were you / Are you smaller in stature than your peers",
                    Responses:[
                        {Value:"Yes",Type:"radio"},
                        {Value:"No",Type:"radio"},
                        {Value:"Unsure",Type:"radio"},
                        {Value:"Comments",Type:"text"}
                    ]
                },
            ]
        }
    ]
}